<template>
  <section class="" id="portfolio">
    <div class="container">
      <div class="row">
        <div
          class="col-lg-2 col-md-1 col-sm-1 portfolio-item"
          v-for="(obj, key) in portfolioJSON"
          :key="key"
        >
          <div class=" col-lg-2 col-md-4 col-sm-4 portfolio-caption">
          <img  :src="`${obj.img}`" v-bind:alt="`${obj.caption}`" width="146px" height="64px">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    portfolioJSON: [
    
      {
        img: "https://res.cloudinary.com/codeinstd/image/upload/v1602680926/consol-logo_ozwvvs.png",
        caption: "Consol",
        title: "",
      },
      {
        img: "https://res.cloudinary.com/codeinstd/image/upload/v1602680926/lawma_ixuqoj.png",
        caption: "Lawma",
        title: "",
      },
      {
        img: "https://res.cloudinary.com/codeinstd/image/upload/v1602680926/tap-n-pay_qzvpda.png",
        caption: "Tap and Pay",
        title: "",
      },
      {
        img:"https://res.cloudinary.com/codeinstd/image/upload/v1602680932/wp-logo_ay0z3m.png",
        caption: "Wolcott Niepce",
        title: "",
      },
    ],
  }),
};
</script>

<style lang="css">








</style>


